import Cross from 'src/components/common/Cross';
import Portal from 'src/components/common/Portal';
import Flex from 'src/styles/layouts/Flex';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import NGHeading from 'src/styles/theme/components/NGHeading';
import { ETextType } from 'src/styles/theme/components/NGText/NGText.enum';
import { ESize } from 'src/styles/theme/utils/enums';

import { FC, useEffect, useState } from 'react';
import { StyledCrossButton, StyledModalMobile } from './ModalMobile.styles';
import { IModalMobile } from './ModalMobile.type';

const ModalMobile: FC<IModalMobile> = ({
	children,
	isOpen = false,
	title = '',
	zIndex,
	increaseCrossButtonVisibility = false,
	containerStyles,
	onClose,
	...otherProps
}) => {
	const [isVisible, setIsVisible] = useState<boolean>(false);

	useEffect(() => {
		let timeoutId: NodeJS.Timeout;

		if (isOpen) {
			setTimeout(() => {
				document.body.style.overflow = 'hidden';
				setIsVisible(true);
			}, 10);
		} else {
			timeoutId = setTimeout(() => {
				setIsVisible(false);
			}, 400);
		}

		return () => {
			clearTimeout(timeoutId);
			document.body.style.overflow = 'unset';
		};
	}, [isOpen]);

	if (!isOpen && !isVisible) {
		return <></>;
	}

	return (
		<Portal selector='body'>
			<StyledModalMobile
				className='swipe-deactivated'
				data-cy='modal-mobile'
				isVisible={isVisible && isOpen}
				zIndex={zIndex}
				{...otherProps}
			>
				{title ? (
					<Flex horizontal={EFlex.between} paddingX={ESize.xs} paddingTop={ESize['s']} paddingBottom={ESize['2xs']}>
						<NGHeading type={ETextType.h3} firstLetterFactor={1.2}>
							{title || ''}
						</NGHeading>
					</Flex>
				) : null}

				{!!onClose ? (
					<StyledCrossButton data-cy='close-modal-mobile' className='cross-button-modal' onClick={onClose}>
						<Cross withBlurBackground={increaseCrossButtonVisibility} />
					</StyledCrossButton>
				) : null}

				<span style={containerStyles}>{children}</span>
			</StyledModalMobile>
		</Portal>
	);
};

export { ModalMobile };
